// extracted by mini-css-extract-plugin
module.exports = {"container":"_2GLPl","noTransitions":"_2Lnl-","cards":"Njqor","card":"_2P5vL","hidden":"_2rtT9"};